import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export function QuickStartGuide() {
  return (
    <Card className="overflow-hidden h-full">
      <CardHeader className="space-y-1 p-4 md:p-6">
        <CardTitle className="text-lg md:text-xl font-semibold break-words">
          Kom i Gang
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 md:p-6">
        <div className="space-y-4">
          <div className="space-y-2">
            {[
              "Opprett din første sak",
              "Utforsk AI-assistenten",
              "Generer dokumenter",
              "Se gjennom lovverk"
            ].map((text, index) => (
              <Button
                key={index}
                variant="ghost"
                className="w-full justify-between text-sm md:text-base p-3 h-auto"
              >
                <span className="truncate">{text}</span>
                <ArrowRight className="h-4 w-4 ml-2 flex-shrink-0" />
              </Button>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}